/** Firestore pricing estimates (USD, approximate Blaze plan). */
const READ_COST = 0.06 / 100000;
const WRITE_COST = 0.18 / 100000;
const DELETE_COST = 0.02 / 100000;
const STORAGE_GB_MONTH = 0.18;

export function estimateOperationCost({
  reads = 0,
  writes = 0,
  deletes = 0,
  storageBytes = 0,
}) {
  const readCost = reads * READ_COST;
  const writeCost = writes * WRITE_COST;
  const deleteCost = deletes * DELETE_COST;
  const storageCost = (storageBytes / (1024 ** 3)) * STORAGE_GB_MONTH;
  const total = readCost + writeCost + deleteCost + storageCost;
  return {
    reads,
    writes,
    deletes,
    storageBytes,
    estimatedReadCost: readCost,
    estimatedWriteCost: writeCost,
    estimatedDeleteCost: deleteCost,
    estimatedStorageCost: storageCost,
    estimatedTotalUsd: total,
  };
}

export function estimateBatchMeta(docCount, batchSize = 500) {
  const batches = docCount === 0 ? 0 : Math.ceil(docCount / batchSize);
  return {
    estimatedBatches: batches,
    estimatedSeconds: Math.max(1, batches * 2),
    estimatedWrites: docCount,
  };
}
